module.exports = __webpack_public_path__ + "img/reminders.ee404c70.webp";